export function paymentMethodPatcher(data) {
    return {
        __typename: 'PaymentMethodData',
        paymentMethods: data.paymentMethods.map(method => ({
            __typename: 'PaymentMethod',
            ...method,
            behaviors: method.behaviors.map(behavior => ({ __typename: 'PaymentMethodBehavior', ...behavior })),
        })),
    };
}
